module.exports = __webpack_public_path__ + "fonts/iconfont.a44a51a6.eot";